import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { painPoints } from '../data/painPoints';
import { renderEmphasis } from '../utils/emphasis';
const STAT_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/3N75Kjihmz16CZmhRcFCX9/Stat.png';
const HIGHLIGHT_STYLE: React.CSSProperties = {
  backgroundImage: 'linear-gradient(90deg, rgba(248,164,0,0.26) 0%, rgba(248,164,0,0.18) 60%, rgba(248,164,0,0.06) 100%)',
  backgroundSize: '100% 80%',
  backgroundPosition: 'center 65%',
  backgroundRepeat: 'no-repeat'
};
export function WhyRewayz() {
  const {
    t,
    lang
  } = useLanguage();
  return <section aria-labelledby="why-title" className="px-5 pb-20 sm:px-6 sm:pb-24 lg:pb-28" data-id="element-234" data-mp="106oq55o8g7dm">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.5
    }} transition={{
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }} className="text-center" data-id="element-235" data-mp="v8vgg2nq0v8l">
        <span className="inline-block rounded-md border border-[rgba(248,164,0,0.45)] px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.08em] text-blue-reways-950-lock" data-id="element-236" data-mp="21ijtp1huc9z0">
          {t.why.eyebrow}
        </span>
        <h2 id="why-title" className="mx-auto mt-4 max-w-[760px] font-hero text-[32px] font-medium leading-[1.2] text-blue-reways-950-lock sm:text-[40px]" data-id="element-237" data-mp="1rs8prey5q0s4">
          {t.why.titleBefore}{' '}
          <span className="box-decoration-clone px-1.5 text-[#F2A007]" style={HIGHLIGHT_STYLE} data-id="element-238" data-mp="1ir0sn07dn5zm">
            {t.why.highlight}
          </span>
          {t.why.titleAfter && <> {t.why.titleAfter}</>}
        </h2>
      </motion.div>

      <motion.ul initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.55,
      delay: 0.1,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto mt-12 grid max-w-[1060px] gap-5 sm:mt-16 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr] lg:gap-6" data-id="element-239" data-mp="18wqv743kvhi1">
        {/* Statistique principale */}
        <li className="relative isolate min-h-[300px] overflow-hidden rounded-[14px] md:col-span-2 lg:col-span-1" data-id="element-240" data-mp="36o07a3iqnyzw">
          <img src={STAT_IMAGE_URL} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover object-[70%_center]" data-id="element-241" data-mp="2wrx5iyrsu2dh" />
          <div aria-hidden="true" className="absolute inset-0 bg-[linear-gradient(90deg,rgba(20,20,90,0.55)_0%,rgba(20,20,90,0.15)_70%)]" data-id="element-242" data-mp="3pgkvv8renhxw" />
          <div className="relative flex h-full flex-col justify-center p-6 sm:p-7" data-id="element-243" data-mp="3kjufslflomch">
            <p className="font-hero text-[52px] font-semibold leading-none text-white sm:text-[60px]" data-id="element-244" data-mp="3fp840h5lwrrv">70%</p>
            <p className="mt-5 max-w-[260px] font-hero text-[20px] font-medium leading-[1.4] text-white sm:text-[22px]" data-id="element-245" data-mp="3apvibzqh1qqv">
              {t.why.statLabel}
            </p>
            <p className="mt-6 text-[11px] text-white/80" data-id="element-246" data-mp="7afy65odq0s0">{t.why.statSource}</p>
          </div>
        </li>

        {painPoints.map(point => <li key={point.id} className="flex flex-col rounded-[14px] bg-white p-6 shadow-[0_18px_45px_rgba(8,8,82,0.06)] sm:p-7" data-id="element-247" data-mp="fm84r5owy9c6">
            <img src={point.illustration} alt="" aria-hidden="true" loading="lazy" className="h-[88px] w-auto self-start object-contain" data-id="element-248" data-mp="oiz2rnn0zy9e" />
            <h3 className="mt-8 font-hero text-[21px] font-medium leading-[1.25] text-blue-reways-950-lock sm:text-[22px]" data-id="element-249" data-mp="ygn5azqvia24">
              {point.title[lang]}
            </h3>
            <p className="mt-4 text-[14px] leading-[1.6] text-grey-800-lock" data-id="element-250" data-mp="17bl2wk4yuazs">
              {point.lines[lang].map((line, i) => <span key={i} className="block" data-id="element-251" data-mp="1cbz53ljvyqpw" data-mpi={i}>
                  {renderEmphasis(line)}
                </span>)}
            </p>
          </li>)}
      </motion.ul>
    </section>;
}